import { useState } from "react";
import { Link,useNavigate } from "react-router-dom";


import { Button } from "components/Button";
import Breadcrumbs from "../../../../components/Breadcrumbs";

import { Pagination,Table,} from "antd";
import { formatDateHandler2 } from "utils/common";
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";
import AssetListFilter from "./../components/AssetListFilter";

import { returnAssetApi } from "api/services/assets";
import AssetFilterDrawer from "components/Drawer/assetFilterDrawer";
import Image from "components/Image";
import AllAssetAddPopup from "components/modelpopup/AllAssetAddPopup";
import ReturnAssetModal from "components/modelpopup/ReturnAssetModal";
import { SkeltonLoader } from "components/skeltonLoader";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Bounce,toast } from 'react-toastify';
import { useAssets } from "./../context/assetContext";

const AllAssets = () => {
  const {
    loading,
    searchText,
    assetData,
    view,
    setView,
    assetModal,
    setAssetModal,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleAssetDetailPage,
    handleDateChange,
    handleClearAll,
    getAssetList,
    setLoading,
    assetCategory,
    isFilterDirty

  } = useAssets();

const [returnAssetModal, setReturnAssetModal] = useState(false)
const [selectedAsset, setSelectedAsset] = useState()
const navigate = useNavigate()
const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

const {
  user,
  userLoading
} = useSelector((state) => state.user);


const columns = [
    {
      title: "Asset Id",
      dataIndex: "id",
      render: (text, record) => (
        <span className="table-avatar">
          {record.id}
        </span>
      )  ,
       sorter: true,
    },
   
  
    {
      title: "Name",
      dataIndex: "name",
      sorter: true,
      render: (text, record, index) => (
        <h2 onClick={()=>handleAssetDetailPage(record.id, index)} className="table-avatar d-flex">
          <a className="avatar">
            <Image 
              src={record?.image} 
              type="object" 
              style={{ 
                width: "40px", 
                height: "40px", 
                objectFit: "contain", 
                borderRadius: "4px" 
              }}
            />
          </a>
          <div>
            <a className="profile-split d-flex flex-column">
              {record.name} 
            </a>
            <small className="table-avatar">
              {record.class_code}
            </small>
          </div>
        </h2>
      )       
    },
    {
      title: "Brand",
      dataIndex: "brand",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label text-center">
        <span className={`badge badge-soft-warning`}>{text}</span>  

  </div>
      )   
    },
    {
      title: "Serial  No",
      dataIndex: "serial_number",
      sorter: true,
  //     render: (text, record) => (
  //       <div className="dropdown action-label text-center">
  //       <span className={`badge badge-soft-pending`}>{text}</span>  

  // </div>
  //     )   
    },
   

    {
      title: "Current Owner",
      dataIndex: "current_user",
      sorter: true,
      render: (text, record) => (
        <h2
        //  onClick={()=>handleAssetDetailPage(record.id, index)} 
          className="table-avatar d-flex">
            {
              !!record?.current_owner&&
              <>
                <a 
        
        className="avatar">
          {/* <img alt="" src={record.profile_image} /> */}
          <Image src={record?.current_owner?.company_user?.profile_image}  type="object"/>
        </a>
        <div>
        <a 
        // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
        className="profile-split d-flex flex-column">
         {record?.current_owner?.company_user?.first_name} {record?.current_owner?.company_user?.last_name} 
        </a>
        <small className="table-avatar">
      {record?.current_owner?.company_user?.emp_no }
     </small> 

      
        </div>

              </>
            }
      
      </h2>
      )   
    },
    // {
    //   title: "Return Date",
    //   dataIndex: "return_date",
    //   sorter: true,
    //   align:"center",
    //   render: (text, record) => 
    //       <>{
    //         formatDateHandler2( record?.return_date) || "-"
    //         }</>,
    // },
    // {
    //   title: "Next Approver",
    //   dataIndex: "next_approver",
    //   sorter: true,
    //   align:"center",
    //   render: (text, record) => 
    //       <>{
    //         record?.next_approver || "N/A"
    //         }</>,
    // },
  
    {
      title: "Purchase Date",
      dataIndex: "purchase_date",
      sorter: true,
      align:"center",
      render: (text, record) => 
          <>{
            formatDateHandler2( record?.purchase_date) || "-"
            }</>,
    },
    {
      title: "Purchase Value",
      dataIndex: "purchase_value",
      sorter: true,
  //     render: (text, record) => (
  //       <div className="dropdown action-label text-center">
  //       <span className={`badge badge-soft-pending`}>{text}</span>  

  // </div>
  //     )   
    },
  //   {
  //     title: "FA No",
  //     dataIndex: "ext_id",
  //     sorter: true,
  // //     render: (text, record) => (
  // //       <div className="dropdown action-label text-center">
  // //       <span className={`badge badge-soft-pending`}>{text}</span>  

  // // </div>
  // //     )   
  //   },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.description}
    //     </span>
    //   )   
    // },

    // {
    //   title: "User",
    //   dataIndex: "first_name",      
    //   render: (text, record, index) => (
    //     <h2>
    //      <a onClick={()=>handleAssetDetailPage(record.id, index)} className="profile-split d-flex flex-column">
    //     {record.company_user.first_name} {record.company_user.last_name}  <span className="table-avatar">
    //       {record.company_user.position_name }
    //     </span> 
    //   </a>    
    //   </h2>
    //   )   
    // },
   
   
    // {
    //   title: "Issue Date",
    //   dataIndex: "issue_date",
    //   render: (text, record) => 
    //   <>{
    //     formatDateHandler2( record?.issue_date)
    //     }</>,
  
    // },
    // {
    //   title: "Return Date",
    //   dataIndex: "return_date",
    //   render: (text, record) => <>{formatDateHandler2(record?.return_date)}</>,
  
    // },
    
   
    // {
    //   title: "Comments",
    //   dataIndex: "comments",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.comments }
    //     </span>
    //   )  
    // },

     {
          title: "Action",
          render: (text , record) => (
            <div className="dropdown dropdown-action text-end">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="material-icons">more_vert</i>
              </Link>
              
                  <div className="dropdown-menu dropdown-menu-right">
                  {/* <Link
                  onClick={()=>{
                    handleEditDocument(recort)
                    setDocumentModal(true)
                    // setSelectedDocument(record)
      
                  }}
                    // to="#"
                    className="dropdown-item"
                    // data-bs-toggle="modal"
                    // data-bs-target="#edit_job"
                  >
                    <i className="fa fa-pencil m-r-5" /> Edit
                  </Link> */}
                  {
                    console.log(user?.role?.access_scope, "((((")
                  }
                  {
                    (user?.role?.access_scope === "all" && !!record?.current_owner) && (
                      <Link
                  onClick={()=>{
                    setReturnAssetModal(true)
                  //   setAssetModal(true)
                    setSelectedAsset(record)
                  //    console.log("clic")
                   }
                
                  }
                    to="#"
                    className="dropdown-item"
                    // data-bs-toggle="modal"
                    // data-bs-target="#delete"
                  >
                    <i className="fa fa-trash m-r-5" /> Return Asset
                  </Link>
                  )
                }
                </div>
                
             
            </div>
          ),
        }
    
  ];


  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {assetData.length === 0 && (
            <div className="row">
              <div className="col-12">
                <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                  <a>No assets found</a>
                </h4>
              </div>
            </div>
          )}
          {assetData.map((asset, index) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3"
              key={asset.id}
              style={{
                ...(isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : { marginBottom: "16px" }),
                display: "flex"
              }}
            >
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: 0,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.2s ease",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
              }}
              onClick={() => handleAssetDetailPage(asset.id, index)}
              >
                {/* Action Menu */}
                {(user?.role?.access_scope === "all" && !!asset?.current_owner) && (
                  <div style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    zIndex: 10
                  }}>
                    <div className="dropdown">
                    <Link
                      to="#"
                      className="action-icon dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "6px",
                          background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          textDecoration: "none",
                          boxShadow: "0 2px 6px rgba(211, 0, 26, 0.3)",
                          cursor: "pointer",
                          transition: "all 0.2s ease"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.1)";
                          e.currentTarget.style.boxShadow = "0 4px 10px rgba(211, 0, 26, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.boxShadow = "0 2px 6px rgba(211, 0, 26, 0.3)";
                        }}
                      >
                        <i className="fa-solid fa-ellipsis-vertical" style={{ fontSize: "12px" }}></i>
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
                      <Link
                          className="dropdown-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            setReturnAssetModal(true);
                            setSelectedAsset(asset);
                        }}
                        to="#"
                      >
                        <i className="fa fa-trash m-r-5" /> Return Asset
                      </Link>
                    </div>
                  </div>
                </div>
                )}

                <div className="card-body" style={{ 
                  padding: isMobile ? "12px" : "16px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column"
                }}>
                  {/* Asset Image */}
                  <div style={{ 
                    marginBottom: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "120px",
                    background: "transparent",
                    borderRadius: "6px",
                    overflow: "hidden"
                  }}>
                        <Image 
                          src={asset?.image} 
                      type="object" 
                          alt="Asset Image" 
                          style={{ 
                        maxWidth: "100%",
                        maxHeight: "100%",
                            objectFit: "contain", 
                        borderRadius: "6px"
                          }} 
                        />
                  </div>

                  {/* Asset Name - Main Highlight */}
                  <div style={{ marginBottom: "12px", paddingRight: asset?.current_owner && user?.role?.access_scope === "all" ? "36px" : "0" }}>
                    <h4 style={{ 
                      fontSize: isMobile ? "15px" : "16px",
                      fontWeight: "600",
                      color: "#1f2937",
                      marginBottom: "6px",
                      lineHeight: "1.3"
                    }}>
                      {asset?.name || "Untitled Asset"}
                    </h4>
                  </div>

                  {/* Asset Details Grid */}
                  <div style={{
                    borderTop: "1px solid #e5e7eb",
                    paddingTop: "12px",
                    marginBottom: "12px",
                    flex: 1
                  }}>
                    <div className="row g-2">
                      {asset?.brand && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Brand
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                            {asset.brand}
                          </div>
                        </div>
                      )}
                      {asset?.serial_number && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Serial
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                            {asset.serial_number}
                          </div>
                        </div>
                      )}
                      {asset?.purchase_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Purchase Date
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(asset.purchase_date)}
                    </div>
                    </div>
                      )}
                      {asset?.purchase_value && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Value
                    </div>
                          <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                            {asset.purchase_value}
                    </div>
                    </div>
                      )}
                    </div>
                  </div>

                  {/* Current Owner */}
                  {asset?.current_owner?.company_user && (
                    <div style={{
                      borderTop: "1px solid #e5e7eb",
                      paddingTop: "12px",
                      marginTop: "auto"
                    }}>
                      <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "6px", fontWeight: "500" }}>
                        Current Owner
                      </div>
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                      }}>
                        <div style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          border: "2px solid #e5e7eb",
                          flexShrink: 0,
                          background: "#ffffff"
                        }}>
                          <Image 
                            src={asset.current_owner.company_user?.profile_image} 
                            type="user" 
                            style={{ objectFit: "cover", width: "100%", height: "100%" }}
                          />
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <Link
                            to={`/employees/${asset.current_owner.company_user.id}`}
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              fontSize: "13px",
                              color: "#D3001A",
                              fontWeight: "600",
                              textDecoration: "none",
                              display: "block",
                              marginBottom: "2px"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.textDecoration = "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            {asset.current_owner.company_user?.first_name} {asset.current_owner.company_user?.last_name}
                          </Link>
                          {asset.current_owner.company_user?.position_name && (
                            <div style={{ 
                              fontSize: "11px", 
                              color: "#6b7280",
                              marginBottom: "2px"
                            }}>
                              {asset.current_owner.company_user.position_name}
                            </div>
                          )}
                          {asset.current_owner.company_user?.emp_no && (
                            <div style={{ 
                              fontSize: "11px", 
                              color: "#6b7280"
                            }}>
                              {asset.current_owner.company_user.emp_no}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };


  const returnAssetHandler = (returnData) => {
    console.log(selectedAsset, "LLLLLLLL")
    returnAssetApi(selectedAsset?.current_owner?.id, returnData).then(res=>{
      toast.success('Asset return request initiated successfully!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        getAssetList()
        setReturnAssetModal(false)
    }).catch(e=>{
      toast.error('Error initiating asset return!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    })
  }


  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Assets"
            title="Dashboard"
            subtitle="Assets"
            modal="#add_assets"
            name="Add Assets"          
            view={view}
            setAssetModal={setAssetModal}
            setView={setView}
          />

          <AssetListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search Assets"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          />



          {view == "grid" ? (
            <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={assetData}
                      rowKey={(record) => record.id}
                      loading={loading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

     

      <AssetFilterDrawer
          searchPlaceholder={"Search Asset"}
          showFilterDrawer={showFilterDrawer}
          handleFilterDrawer={handleFilterDrawer}

          handleFilterChange={handleFilterChange}
          filters={filters}
          handleInputChange={handleInputChange}
          handleApplyFilter={handleApplyFilter}
          filterLoading={filterLoading}
          handleDateChange={handleDateChange}
          handleClearAll={handleClearAll}
          isFilterDirty={isFilterDirty}
        />

      <AllAssetAddPopup getAssetList={getAssetList} assetCategory={assetCategory} setSelectedAsset={setSelectedAsset} setLoading={setLoading} selectedAsset={selectedAsset} loading={loading} assetModal={assetModal} setAssetModal={setAssetModal} />




      <ReturnAssetModal returnAssetModal={returnAssetModal} setReturnAssetModal={setReturnAssetModal} returnAssetHandler={returnAssetHandler} Name="Return Asset" />

    </div>
  );
};

export default AllAssets;
